import Liquidity from '../views/Pool'

export default Liquidity